export default {
  default: () => import("/builds/rialtic/workflows/console-ui/apps/disputes/layouts/default.vue"),
  "claim-lab": () => import("/builds/rialtic/workflows/console-ui/apps/claim-lab/layouts/claim-lab.vue"),
  "auth-public": () => import("#build/layouts.public.7de2346e.vue")
}